/**
 * [自定义错误提示code]
 * @author: Fu Xiaochun
 * @date: 2021-08-09 
 */
// 当接口错误代码为一下值时，不在拦截器里做默认toast提示，需要在业务代码中自定义操作。

export default [
    54005,  // 当前运费模板存在进行中或者未开始的运费调控
];